import React from "react";
import cn from "classnames";
import styles from "./Overview.module.sass";
import TooltipGlodal from "../../../components/TooltipGlodal";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import Tooltip from "../../../components/Tooltip";
import Balance from "../../../components/Balance";
import DateFilter from "../Filters/DateFilter";
import {getIsoDateStr} from "../../../utils/analyticsUtils";

const daysToSubtract = {
  1: 0, // Today
  2: 7, // Last 7 days
  3: 30, // Last 30 days
  4: 90, // Last 90 days
  5: 365, // Last 365 days
}

const Overview = ({ className, dateFilter, setDateFilter, overviewData, isLoading }) => {

  const handleChange = (value, from, to) => {
    switch (value) {
      case 1:
        setDateFilter({
          currStart: getIsoDateStr(new Date()),
          currEnd: getIsoDateStr(new Date()),
          filterValue: value,
          prevStart: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 1))),
          prevEnd: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 1))),
        });
        break;
      case 2:
        //if 7 days then currStart is 7 days ago and currEnd is today and prevStart is 14 days ago and prevEnd is 7 days ago
        setDateFilter({
          currStart: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 7))),
          currEnd: getIsoDateStr(new Date()),
          filterValue: value,
          prevStart: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 14))),
          prevEnd: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 7))),
        });
        break;
      case 3:
        //if 30 days then currStart is 30 days ago and currEnd is today and prevStart is 60 days ago and prevEnd is 30 days ago
        setDateFilter({
          currStart: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 30))),
          currEnd: getIsoDateStr(new Date()),
          filterValue: value,
          prevStart: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 60))),
          prevEnd: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 30))),
        });
        break;
      case 4:
        //if 90 days then currStart is 90 days ago and currEnd is today and prevStart is 180 days ago and prevEnd is 90 days ago
        setDateFilter({
          currStart: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 90))),
          currEnd: getIsoDateStr(new Date()),
          filterValue: value,
          prevStart: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 180))),
          prevEnd: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 90))),
        });
        break;
      case 5:
        //if 365 days then currStart is 365 days ago and currEnd is today and prevStart is 730 days ago and prevEnd is 365 days ago
        setDateFilter({
          currStart: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 365))),
          currEnd: getIsoDateStr(new Date()),
          filterValue: value,
          prevStart: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 730))),
          prevEnd: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 365))),
        });
        break;
      case 6:
        //if custom date then currStart is from and currEnd is to and prevStart is from - to -1 days back from from and prevEnd is from - to - 1 days back from to
        setDateFilter({
          currStart: getIsoDateStr(new Date(from)),
          currEnd: getIsoDateStr(new Date(to)),
          filterValue: value,
          prevStart: getIsoDateStr(new Date(new Date(from).setDate(new Date(from).getDate() - (new Date(to).getDate() - new Date(from).getDate() + 1)))),
          prevEnd: getIsoDateStr(new Date(new Date(to).setDate(new Date(to).getDate() - (new Date(to).getDate() - new Date(from).getDate() + 1)))),
        });
        break;
      default:
        break;
    }
  }

  return (
    <>
      <Card
        className={cn(styles.card, className)}
        title="Overview"
        classTitle="title-purple"
        head={
          <DateFilter valueFilterByDate={dateFilter.filterValue} onDateFilterChange={handleChange}/>
        }
      >
        {isLoading ? (<div>loading...</div>) : (<div className={styles.overview}>
          <div className={styles.list}>
            <div
              className={styles.item}
              style={{ backgroundColor: '#edf8f2' }}
            >
              <div className={styles.icon}>
                <Icon name="activity" size="24" />{" "}
              </div>
              <div className={styles.line}>
                <div className={styles.details}>
                  <div className={styles.category}>
                    Orders Picked{" "}
                    <Tooltip
                      className={styles.tooltip}
                      title="Small description"
                      icon="info"
                      place="right"
                    />
                  </div>
                  <div className={styles.counter}>{overviewData.ordersPicked.numerator}/{overviewData.ordersPicked.denominator}</div>
                  <div className={styles.indicator}>
                    <Balance className={styles.balance} value={overviewData.ordersPicked.change} />
                  </div>
                </div>
              </div>
            </div>

            <div
              className={styles.item}
              style={{ backgroundColor: '#ecf9fe' }}
            >
              <div className={styles.icon}>
                <Icon name="shopping-bag" size="24" />{" "}
              </div>
              <div className={styles.line}>
                <div className={styles.details}>
                  <div className={styles.category}>
                    Orders Packed{" "}
                    <Tooltip
                      className={styles.tooltip}
                      title="Small description"
                      icon="info"
                      place="right"
                    />
                  </div>
                  <div className={styles.counter}>{overviewData.ordersPacked.numerator}/{overviewData.ordersPacked.denominator}</div>
                  <div className={styles.indicator}>
                    <Balance className={styles.balance} value={overviewData.ordersPacked.change} />
                  </div>
                </div>
              </div>
            </div>


            <div
              className={styles.item}
              style={{ backgroundColor: '#f2efff' }}
            >
              <div className={styles.icon}>
                <Icon name="payment" size="24" />{" "}
              </div>
              <div className={styles.line}>
                <div className={styles.details}>
                  <div className={styles.category}>
                    Items Picked{" "}
                    <Tooltip
                      className={styles.tooltip}
                      title="Small description"
                      icon="info"
                      place="right"
                    />
                  </div>
                  <div className={styles.counter}>{overviewData.itemsPicked.numerator}/{overviewData.itemsPicked.denominator}</div>
                  <div className={styles.indicator}>
                    <Balance className={styles.balance} value={overviewData.itemsPicked.change} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>)}
      </Card>
      <TooltipGlodal />
    </>
  );
};

export default Overview;
